import { render, staticRenderFns } from "./DigitalClinicsCategoryModal.vue?vue&type=template&id=4356426b"
import script from "./DigitalClinicsCategoryModal.vue?vue&type=script&lang=js"
export * from "./DigitalClinicsCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./DigitalClinicsCategoryModal.vue?vue&type=style&index=0&id=4356426b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports